import { render, staticRenderFns } from "./editsurattugas.vue?vue&type=template&id=5f65cf90&"
import script from "./editsurattugas.vue?vue&type=script&lang=js&"
export * from "./editsurattugas.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports